module.exports = __webpack_public_path__ + "img/cta-food-mob-fr.37a93c58.png";